export var StateBuildingGraphics;
(function (StateBuildingGraphics) {
    StateBuildingGraphics[StateBuildingGraphics["Idle"] = 1] = "Idle";
    StateBuildingGraphics[StateBuildingGraphics["RunningProduction"] = 2] = "RunningProduction";
    StateBuildingGraphics[StateBuildingGraphics["FinishedProduction"] = 3] = "FinishedProduction";
})(StateBuildingGraphics || (StateBuildingGraphics = {}));



//////////////////
// WEBPACK FOOTER
// ./src/graphics/StateBuildingGraphics.ts
// module id = 153
// module chunks = 3